module.exports = __webpack_public_path__ + "img/ostoja_spokoju_i.c8ad97bb.jpg";